export default "__VITE_ASSET__CKJsP_Yi__"